import { useApi } from '@/api';
import { useTypedStore, type RootState } from '@/store';
import type { GetSettingsResponse } from '@/types/openapi-ts';
import type { TypedStoreModule } from '@/types/vuex';
import type { ActionContext } from 'vuex';

export interface ReportsState {
  panelSettings: GetSettingsResponse['payload']
}

const stateData = () => ({
  panelSettings: {
    telegram_bot: {} as GetSettingsResponse['payload']['telegram_bot'],
    supported_languages: [],
    reports: {} as GetSettingsResponse['payload']['reports'],
    kyc: {
      enabled: false,
    },
  } satisfies GetSettingsResponse['payload'],
});

const getters = {
  reportsSettings: (state: ReportsState) => state.panelSettings.reports || {},
  panelSettings: (state: ReportsState) => state.panelSettings || {},
  supportedLanguages: (state: ReportsState) => state.panelSettings.supported_languages,
}

const mutations = {
  getSettings(state: ReportsState, settings: GetSettingsResponse['payload']) {
    state.panelSettings = settings;
  },
}

const actions = {
  async getSettings({ commit }: ActionContext<ReportsState, RootState>) {
    const api = useApi();
    const store = useTypedStore();

    try {
      if (store.getters['auth/adminAcl'].is_superuser
      || store.getters['auth/adminAcl'].teams.length) {
        const { data: { payload } } = await api.getSettings();
        commit('getSettings', payload);
      }
    } catch (error) {
      commit('getSettings', {});
    }
  },
}

const storeModule = {
  state: stateData() as ReportsState,
  getters,
  mutations,
  actions,
  namespaced: true,
}

export type ReportsModule = TypedStoreModule<'reports', typeof storeModule>;

export default storeModule;
